import { createSlice } from "@reduxjs/toolkit";

interface ShowDataState {
  showData: boolean;
  wasClicked: boolean;
}

const initialState: ShowDataState = {
  showData: true,
  wasClicked: false,
};

const showDataSlice = createSlice({
  name: "showData",
  initialState,
  reducers: {
    toggleShowData: (state) => {
      state.showData = !state.showData;
    },
    setWasClicked: (state) => {
      state.wasClicked = !state.wasClicked;
    },
  },
});

export const { toggleShowData, setWasClicked } = showDataSlice.actions;
export default showDataSlice.reducer;
